var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kst-action',[_c('kst-action-item',[_c('kst-button',{attrs:{"action-mode":"","module":_vm.Model.Item.Module,"moduleType":_vm.Model.Item.ModuleType.Edit,"urlParams":_vm.urlParams}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }